import { RunServiceRequestPassengers } from '../../Checkout/types';

export interface ModifiedService {
	service: {
		id?: string;
		allowedSegments?: string[][];
		allowedPassengers?: string[][];
	};
	segmentId: string;
	passengerId: string;
	count?: number;
}

export interface ServiceModificationHookResults {
	runServiceRequest: (passengers: RunServiceRequestPassengers[]) => Promise<any>;
}

export enum CheckinStep {
	Passengers = '',
	Meal = 'meal',
	Upgrade = 'upgrade',
	Baggage = 'baggage',
	Seats = 'seats',
	Insurance = 'insurance',
	Extras = 'extras',
	Restrictions = 'restrictions',
	Payment = 'payment'
}

export interface SaveLoyaltyNumberData {
	travellerId: string;
	code: string;
}
